import React, { useEffect, useState } from "react";

import ava01 from "../assets/img/ava-1.jpg";
import ava02 from "../assets/img/ava-2.jpg";
import ava03 from "../assets/img/ava-3.jpg";
import { Col } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "../styles/our-member.css";
import { getTopHosts } from "../util/api";
import Avatar from "../assets/img/user.png";
import moment from "moment";

const OUR__MEMBERS = [
  {
    name: "Jhon Doe",
    experience: "5 years of experience",
    fbUrl: "#",
    instUrl: "#",
    twitUrl: "#",
    linkedinUrl: "#",
    imgUrl: ava01,
  },

  {
    name: "David Lisa",
    experience: "5 years of experience",
    fbUrl: "#",
    instUrl: "#",
    twitUrl: "#",
    linkedinUrl: "#",
    imgUrl: ava02,
  },

  {
    name: "Hilton King",
    experience: "5 years of experience",
    fbUrl: "#",
    instUrl: "#",
    twitUrl: "#",
    linkedinUrl: "#",
    imgUrl: ava03,
  },

  {
    name: "Jhon Doe",
    experience: "5 years of experience",
    fbUrl: "#",
    instUrl: "#",
    twitUrl: "#",
    linkedinUrl: "#",
    imgUrl: ava01,
  },
];

const OurMember = () => {
  const [hosts, setHosts] = useState([]);
  useEffect(() => {
    getHosts();
  }, []);
  const getHosts = () => {
    getTopHosts()
      .then((res) => {
        const firstFourItems = res.slice(0, 4);
        setHosts(firstFourItems);
      })
      .catch((err) => console.log(err));
  };
  const joinDate = "2023-05-04T06:14:25.675509";

  // Calculate the months of experience from the join date to the current date
  const monthsOfExperience = moment().diff(moment(joinDate), "months");
  console.log("monthsOfExperience", monthsOfExperience);

  const navigate = useNavigate();
  return (
    <>
      {hosts?.map((item, index) => (
        <Col
          lg="3"
          md="3"
          sm="4"
          xs="6"
          className="mb-4"
          key={index}
          onClick={() =>
            navigate(
              `/TopRatedListings?myObject=${encodeURIComponent(
                JSON.stringify(item)
              )}`
            )
          }
        >
          <div className="single__member">
            <div className="single__member__img">
              <img
                src={
                  item.profileImageUrl == null ? Avatar : item.profileImageUrl
                }
                alt=""
                className="w-100"
                style={{ height: 200 }}
              />
              {/* <div className="single__member__social">
                <Link to={item.fbUrl}>
                  <i class="ri-facebook-line"></i>
                </Link>
                <Link to={item.instUrl}>
                  <i class="ri-instagram-line"></i>
                </Link>
                <Link to={item.linkedinUrl}>
                  <i class="ri-linkedin-line"></i>
                </Link>
                <Link to={item.twitUrl}>
                  <i class="ri-twitter-line"></i>
                </Link>
              </div> */}
            </div>

            <h6 className="text-center mb-0 mt-3">{item.userName}</h6>
            <p className="section__description text-center">
              {moment().diff(moment(item.joininDate), "months")} Months of
              experience
            </p>
          </div>
        </Col>
      ))}
    </>
  );
};

export default OurMember;
